export const ArizonaActionType = Object.freeze({
  SET_CHART: "Arizona:: Set chart",
});
